import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { API_BASE_URL, API_ENVIRONMENT } from './lib/api';
import { queryClient } from './lib/queryClient';
import { hideSplash } from './splash';
import { isFormsHost } from './lib/site/config';
import './reticle-dev';

// Which backend this bundle was built against is baked in and invisible from
// the UI, so say it out loud - a tester handed a URL can check the console
// instead of guessing whether they are on the staging build.
if (API_ENVIRONMENT !== 'production') {
  console.info(`Naurist dashboard: ${API_ENVIRONMENT} API (${API_BASE_URL})`);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// The forms site is served off this same bundle and carries no mark of ours
// anywhere — see `usePublicFormHead`. The hostname list in `index.html` keeps
// the splash off a practitioner's subdomain before the splash is ever drawn;
// this is the case that list cannot answer for, a developer running the forms
// preview on localhost, which is the dashboard's hostname too.
if (isFormsHost()) {
  hideSplash({ immediate: true });
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// The splash in `index.html` has been up since the first byte; this is the app
// saying it has the window now. It waits for the paint and for its own minimum
// before it goes — see `hideSplash`. Not awaited on the session: Clerk's
// restore and the workspace calls have screens of their own, and holding a
// brand mark over them would only hide what they are saying.
hideSplash();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
